var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainFrame"},[_c('div',{staticClass:"headerBox"},[_c('myHeader')],1),_vm._v(" "),_c('div',{staticClass:"leftMemuBox"},[_c('myLeft')],1),_vm._v(" "),_c('div',{staticClass:"mainBox",class:{testBg:_vm.environmental=='test',devBg:_vm.environmental=='dev'}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3379ac1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mainFrame.vue
// module id = null
// module chunks = 